import React from "react";
import { Pagination } from "antd";
import DefaultColumn, { DefaultColumnLayout } from "./Column";
import GridLayout from "../GridLayout";
import "./index.less";
const layout = (n) => Array.from({length: n}).map(() => '.').join("\n")
const DefaultListLayout = ({ children }) => <GridLayout gap={12} layout={layout(React.Children.count(children))}>{children}</GridLayout>
export default ({
  data,
  pagination,
  loading,
  columns,
  className = "",
  onChange,
  Column = DefaultColumn,
  columnLayout = DefaultColumnLayout,
  Layout = DefaultListLayout,
  rowKey = "id",
  style,
  columnProps
}) => {
  const paginationProps = {
    showSizeChanger: true,
    showQuickJumper: true,
    ...pagination,
    showTotal: (total) => `共${total}条数据`,
  };

  return (
    <div className="TUI-List--Wrap" style={style}>
      <div className={["TUI-List", className].join(" ")}>
        <Layout>
          {(data || []).map((d) => (
            <Column
              key={d[rowKey]}
              schema={columns}
              data={d}
              layout={columnLayout}
              {...columnProps}
            />
          ))}
        </Layout>
      </div>
      {pagination ? (
        <Pagination {...paginationProps} onChange={onChange} />
      ) : null}
    </div>
  );
};
